import React from 'react';
import { Layout, Menu, Row } from 'antd';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Icons from '@ant-design/icons';
import { useCallback } from 'react';
import { COLORS } from '../../utils/constants';
import {
  BOOKINGSPATH,
  EVENTMANAGEMENTPATH,
  FACILITYMANAGEMENTPATH,
  SPORTSMANAGEMENTPATH,
  TRANSACTIONSPATH,
  USERMANAGEMENTPATH,
} from '../../routes/routePaths';
import AppLogo from '../../assets/App-Logo.png';

const menu = [
  {
    key: 'user-management',
    label: 'User Management',
    icon: 'TeamOutlined',
    path: USERMANAGEMENTPATH,
  },
  {
    key: 'facility-management',
    label: 'Facility Management',
    icon: 'ExpandOutlined',
    path: FACILITYMANAGEMENTPATH,
  },
  {
    key: 'sports-management',
    label: 'Sports Management',
    icon: 'DribbbleOutlined',
    path: SPORTSMANAGEMENTPATH,
  },
  {
    key: 'bookings',
    label: 'Bookings',
    icon: 'ProfileOutlined',
    path: BOOKINGSPATH,
  },
  {
    key: 'event-management',
    label: 'Event Management',
    icon: 'StarOutlined',
    path: EVENTMANAGEMENTPATH,
  },
  {
    key: 'transactions',
    label: 'Transactions',
    icon: 'TransactionOutlined',
    path: TRANSACTIONSPATH,
  },
];

const { Sider } = Layout;

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getIcon = useCallback((iconName: string) => {
    const Icon = (Icons as any)[iconName];
    return Icon ? <Icon /> : null;
  }, []);

  const menuItems = menu.map((item) => ({
    key: item.key,
    icon: getIcon(item.icon),
    label: item.label,
  }));

  return (
    <StyledSider>
      <StyledLogoRow>
        <StyledLogo src={AppLogo} alt="SportsSeek" />
      </StyledLogoRow>
      <StyledMenu
        theme="light"
        mode="inline"
        selectedKeys={[
          menu.find((item) => location.pathname.startsWith(item.path))?.key ||
            '',
        ]}
        items={menuItems}
        onClick={({ key }) => {
          const menuItem = menu.find((item) => item.key === key);
          if (menuItem) {
            navigate(menuItem.path);
          }
        }}
      />
    </StyledSider>
  );
};

const StyledSider = styled(Sider)`
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  & .ant-layout-sider-children {
    background: ${COLORS.white.primary};
    width: 256px;
  }
`;

const StyledLogoRow = styled(Row)`
  height: 105px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.white.primary};
  border-inline-end: 1px solid rgba(5, 5, 5, 0.06);
`;
const StyledLogo = styled.img`
  height: 90px;
  width: 220px;
`;

const StyledMenu = styled(Menu)`
  height: 100%;
  .ant-menu-item {
    height: 56px;
    margin-inline: 0;
    width: 100%;
    border-radius: 0;
  }
  .ant-menu-item-selected {
    border-right: 2px solid ${COLORS.blue.primary} !important;
  }
`;

export default Sidebar;
